export const feverColor = (type) => {
  if (type === 0) {
    return '#2F80ED';
  }

  if (type === 1) {
    return '#F0B000';
  }

  return '#EB5757';
};
